import { SettingsNavigation } from './SettingsNavigation';
import { Box, Stack } from '@mui/material';
import { Outlet } from 'react-router';
import { FC } from 'react';
import { useBreadcrumbsNavigation } from '../components/BreadcrumbsNavigation';

export const SettingsLayout: FC = () => {
	const { BreadcrumbsNavigation } = useBreadcrumbsNavigation({ separator: '>' });
	return (
		<Stack display={'flex'} direction={{ xs: 'column', sm: 'row' }} flexWrap={'nowrap'} p={{ xs: 3, sm: 0 }}>
			<Stack flexBasis={'20rem'} flexDirection={'column'} minWidth={'20rem'} py={5} px={7.5} sx={{ display: { xs: 'none', sm: 'flex' } }}>
				<SettingsNavigation />
			</Stack>
			<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>{BreadcrumbsNavigation}</Box>
			<Box width={'100%'}>
				<Outlet />
			</Box>
		</Stack>
	);
};
